import angular from 'angular';

let fastSearchModule = angular.module('app.catalog.fastSearch', []);

export default fastSearchModule;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/fast-search/fast-search.js
 **/